import { render, staticRenderFns } from "./phone-verification.vue?vue&type=template&id=65b6f2bc&scoped=true&"
import script from "./phone-verification.vue?vue&type=script&lang=js&"
export * from "./phone-verification.vue?vue&type=script&lang=js&"
import style0 from "./phone-verification.vue?vue&type=style&index=0&lang=css&"
import style1 from "./phone-verification.vue?vue&type=style&index=1&id=65b6f2bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b6f2bc",
  null
  
)

export default component.exports